// extracted by mini-css-extract-plugin
export var link = "_so-0";